import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const chatChainOfThoughtDefaultVariants = {}
const chatChainOfThoughtCompoundVariants = []

const chatChainOfThoughtSlotNames = [
  [
    "root",
    "chatChainOfThought__root"
  ],
  [
    "trigger",
    "chatChainOfThought__trigger"
  ],
  [
    "content",
    "chatChainOfThought__content"
  ],
  [
    "preview",
    "chatChainOfThought__preview"
  ],
  [
    "steps",
    "chatChainOfThought__steps"
  ],
  [
    "step",
    "chatChainOfThought__step"
  ],
  [
    "stepLabel",
    "chatChainOfThought__stepLabel"
  ],
  [
    "stepBody",
    "chatChainOfThought__stepBody"
  ]
]
const chatChainOfThoughtSlotFns = /* @__PURE__ */ chatChainOfThoughtSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, chatChainOfThoughtDefaultVariants, getSlotCompoundVariant(chatChainOfThoughtCompoundVariants, slotName))])

const chatChainOfThoughtFn = memo((props = {}) => {
  return Object.fromEntries(chatChainOfThoughtSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const chatChainOfThoughtVariantKeys = []
const getVariantProps = (variants) => ({ ...chatChainOfThoughtDefaultVariants, ...compact(variants) })

export const chatChainOfThought = /* @__PURE__ */ Object.assign(chatChainOfThoughtFn, {
  __recipe__: false,
  __name__: 'chatChainOfThought',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: chatChainOfThoughtVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, chatChainOfThoughtVariantKeys)
  },
  getVariantProps
})